import React, {useState} from 'react';
import {toast} from 'react-toastify';
import {Button, Input} from 'reactstrap';
import {getYoutubePreviewForEntity} from 'utils/api';
import SpinnerButton from 'components/SpinnerButton';

const AddYoutubeSourceInput = ({activeEntityId, addSourceToEntity}) => {
    const [fetchingContent, setFetchingContent] = useState(false);
    const [inputValue, setInputValue] = useState('');

    const fetchYoutubeContent = async() => {
        try {
            setFetchingContent(true);
            const params = {
                url: inputValue ? inputValue.trim() : '',
                entityId: activeEntityId,
            };
            let data = await getYoutubePreviewForEntity(params);
            addSourceToEntity(data.content, 'youtube');
            setInputValue('');
            toast.info('Source successfully added');
            setFetchingContent(false);
        } catch(e) {
            setFetchingContent(false);
            if(e.message && e.message.length < 150) {
                toast.error(e.message);
            }
            throw e.message;
        }
    };

    const handleSearchChange = (e) => {
        if(e.key === 'Enter') {
            if(e.target.value.trim()) {
                fetchYoutubeContent();
            }
        } else {
            handleInputChange(e.target.value);
        }
    };

    const handleInputChange = (value) => {
        setInputValue(value);
    };

    return (
        <div className="w-100">
            <div className="d-flex">
                <div className="w-100 d-flex">
                    <div className="d-flex justify-content-between w-100">
                        <div className="position-relative w-100">
                            <i className="fab fa-youtube add-entity-source-input-icon" style={{color: '#FF0000'}}/>
                            <Input
                                onKeyPress={(e) => handleSearchChange(e)}
                                onChange={(e) => handleSearchChange(e)}
                                value={inputValue}
                                placeholder="Enter a Youtube username URL, channel URL or playlist URL"
                                type="text"
                                className="create-fetch_input"
                                style={{padding: '0 40px'}}
                                autoComplete="off"
                            />
                            {inputValue && inputValue.trim() && (
                                <i
                                    onClick={() => handleInputChange('')}
                                    className="fa fa-times-circle"
                                    style={{
                                        position: 'absolute',
                                        cursor: 'pointer',
                                        right: '0',
                                        top: '0',
                                        padding: '10.5px',
                                    }}
                                />
                            )}
                        </div>
                        {/*<Button*/}
                        {/*    className="calltoaction-button"*/}
                        {/*    style={{marginLeft: '10px', lineHeight: '0', minWidth: '75px'}}*/}
                        {/*    onClick={fetchYoutubeContent}*/}
                        {/*    disabled={!inputValue.trim() || fetchingContent}*/}
                        {/*>*/}
                        {/*    {fetchingContent ?*/}
                        {/*        <div className="flex-centered">*/}
                        {/*            <i className="fa fa-spinner fa-spin"/>*/}
                        {/*        </div>*/}
                        {/*        :*/}
                        {/*        <React.Fragment>*/}
                        {/*            <span style={{fontSize: '14px'}}><i style={{display: 'inline'}}*/}
                        {/*                                                className="fas fa-plus"/></span>&nbsp;*/}
                        {/*            <span style={{fontSize: '16px'}}>Add</span>*/}
                        {/*        </React.Fragment>*/}
                        {/*    }*/}
                        {/*</Button>*/}
                        <div style={{marginLeft: '10px'}}>
                            <SpinnerButton
                                minWidth="75px"
                                title="Add"
                                iconClass="fas fa-plus"
                                submitting={fetchingContent}
                                onClick={fetchYoutubeContent}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddYoutubeSourceInput;
